import React, { useEffect, useState } from "react";
import { LoginScreen, Link, Icon, Input, Button, Dialog } from "@abb/abb-common-ux-react";
import { useNavigate } from "react-router-dom";
import { Auth, Amplify, Hub } from "aws-amplify";
import { awsConfig } from "../../components/Authentication/aws-config";
import { MESSAGES } from "../../strings";
import apiRequest from "../../config/api";
import "./login.css";
import { encryptData } from "../../utils/util";
import qrcode from 'qrcode'
import { BASE_URL } from "../../config/apiUrls";

Amplify.configure(awsConfig);

function ABBLogin() {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [isError, setIsError] = React.useState(false);
  const [showVerifyMFA, setShowVerifyMFA] = useState(false);
  const [totpCode, settotpCode] = React.useState();
  const [getLoginConfig, setgetLoginConfig] = useState({});
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [isCancelEnabled, setIsCancelEnabled] = useState(true);
  const [ShowQRCode, setShowQRCode] = useState(false);
  const [QRCodeURL, setQRCodeURL] = useState('');
  const [user, setUser] = useState(null);
  const [showPostCannotGiveCodeStep, setShowPostCannotGiveCodeStep] = useState(false);
  const [showSecretKey, setShowSecretKey] = useState(false);
  const [ShowMFASettingUpMessage, setShowMFASettingUpMessage] = useState(false);
  const [showSessionTimeout, setShowSessionTimeout] = useState(false);

  useEffect(() => {
    const redirectToLogin = () => {
      try {
        if (window.location.pathname !== "/") {
          navigate("../");
        }
      } catch (err) { }
    };
    localStorage.setItem("error", "");
    redirectToLogin();
  }, []);

  // Listen for federated (ABBSAML) sign-in and redirect to /ratingen
  useEffect(() => {
    const unsubscribe = Hub.listen("auth", async ({ payload }) => {
      if (payload.event === "signIn") {
        const signedInUser = payload.data;
        if (signedInUser) {
          const encryptedUserName = encryptData(signedInUser.username);
          localStorage.setItem("logged_in_user", encryptedUserName);
          await postLoginFetchUserDetails(signedInUser.username);
          navigate("/ratingen");
        }
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (ShowQRCode && QRCodeURL) {
      // Generate QR code and display it on the screen
      // Timing issue where the QR code is not generated in time
      let canvas = document.getElementById('canvas');
      qrcode.toCanvas(canvas, QRCodeURL, function (error) {
        if (error) {
          console.error('Error generating QR code:', error);
        }
      });
    }
  }, [ShowQRCode, QRCodeURL]);

  useEffect(() => {
    let timer;
    if (ShowQRCode) {
      // Show modal after 3 minutes i.e. 180,000 milliseconds
      timer = setTimeout(() => {
        setShowSessionTimeout(true);
      }, 180000);
    }
    return () => clearTimeout(timer); // Cleanup the timer when we exit the screen
  }, [ShowQRCode]);

  const handleForgotPasswordClick = () => {
    navigate("../forgot-password");
  };

  const showSuccess = () => {
    navigate("./ratingen");
  };

  const lawText =
    "This is a private system. Do not attempt to logon unless you are an authorized user. " +
    "Any authorized or unauthorized access and use may be monitored and can result in " +
    "criminal or civil prosecution under applicable law.";

  const [usersstate, setUsersState] = useState({
    username: "",
    password: "",
    error: false,
  });

  const gotSignUp = () => {
    navigate("../signup");
  };

  const postLoginFetchUserDetails = async (username) => {
    try {
      const userInfo = await apiRequest({
        method: "GET",
        endPoint: `rbac-get?id=${username.trim()}`,
        baseURL: BASE_URL
      });
      if (userInfo) {
        localStorage.setItem("USER_INFO", JSON.stringify(userInfo));
      } else {
        postLoginFetchUserDetails(username);
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  const handleLoginSubmit = async (username, password) => {
    localStorage.clear();
    setIsError(false);
    setLoading(true);
    try {
      const signInOptions = {
        username,
        password,
      };
      setgetLoginConfig(signInOptions);
      const user = await Auth.signIn(signInOptions);
      // Check if MFA is required for the user
      const challengeParam = user.challengeName;
      if (challengeParam === "MFA_SETUP") {
        try {
          setLoading(false);
          const secretCode = await Auth.setupTOTP(user);
          setUser(user);
          // QR code string
          const authCode = `otpauth://totp/${process.env.REACT_APP_AWS_COGNITO_DOMAIN}.auth.eu-central-1.amazoncognito.com:` + user.username + "?secret=" + secretCode;
          setShowQRCode(true);
          setQRCodeURL(authCode);

        } catch (error) {
          console.error("Error during MFA setup:", error);
        }
      } else if (challengeParam === "SOFTWARE_TOKEN_MFA") {
        setLoading(false);
        setShowVerifyMFA(true);
        settotpCode()
        setUser(user);
        // const totpCode = prompt(
        //   "Enter One--time password code from your authenticator app:"
        // );
        //await verifyMFACode(user, username)
      }

      const encryptedUserName = encryptData(username);
      localStorage.setItem("logged_in_user", encryptedUserName);
      localStorage.setItem("error", "");
      setIsError(false);
      setUsersState({ ...usersstate, iserror: false });
    } catch (error) {

      setLoading(false);
      setIsError(true);

      switch (error.code) {
        case "UserNotConfirmedException":
          localStorage.setItem("error", "User account not confirmed. Please check your email for verification instructions.");
          break;
        // Incorrect Username
        case "UserNotFoundException":
        // Incorrect Password
        // falls through
        case "NotAuthorizedException":
          localStorage.setItem("error", "Incorrect username or password.");
          break;
        case "PasswordResetRequiredException":
          localStorage.setItem("error", "Password reset required. Please reset your password.");
          break;
        case "LimitExceededException":
          localStorage.setItem("error", "Attempt limit exceeded. Please try again later.");
          break;
        default:
          localStorage.setItem("error", "An unexpected error occurred. Please try again later.");
          break;




      }
      setUsersState({
        ...usersstate,
        iserror: true,
        error: true,
      });
    };
  }
  const verifyMFACode = async () => {
    setIsError(false);
    setLoading(true);
    if (totpCode) {
      setIsSaveEnabled(false);
      setIsCancelEnabled(false);
      const user = await Auth.signIn(getLoginConfig);
      try {
        let confirmSignInResp = await Auth.confirmSignIn(
          user,
          totpCode,
          "SOFTWARE_TOKEN_MFA"
        );
        // Check if MFA challenge is successfully completed before proceeding
        if (confirmSignInResp.username) {
          // await postLoginFetchUserDetails(getLoginConfig.username);

          setShowVerifyMFA(false)
          setLoading(false);
          setIsError(false);
          showSuccess();
        }
      } catch (e) {
        setLoading(false);
        setIsSaveEnabled(true);
        setIsCancelEnabled(true);
        if (e.name === 'CodeMismatchException') {
          const message = e.message;
          const truncatedMessage = message.split(':')[0];
          localStorage.setItem("error", truncatedMessage);
        } else {
          console.log('An unexpected error occurred:', e.message);
          localStorage.setItem("error", e.message);
        }
        setIsError(true);
      }
    } else {
      setLoading(false);
      setIsError(true);
      setIsSaveEnabled(false);
      setIsCancelEnabled(true);
      localStorage.setItem("error", "Enter Valid Code");
    }
  }

  const verifyMFASetup = async () => {
    setIsError(false);
    setLoading(true);
    if (totpCode) {
      try {
        // Verify the TOTP token
        await Auth.verifyTotpToken(user, totpCode);
        // Reaching here means MFA setup is successful

        // setLoading(false);
        setShowMFASettingUpMessage(true);
        await postLoginFetchUserDetails(getLoginConfig.username);
        setShowVerifyMFA(false)
        setIsError(false);
        showSuccess();

      } catch (error) {
        setIsError(true);
        localStorage.setItem("error", error.message);
        setLoading(false);
      }
    } else {
      setIsError(true);
      localStorage.setItem("error", "Enter Valid Code");
    }
  };


  const closeDialog = () => {
    setShowPostCannotGiveCodeStep(false);
    setShowSessionTimeout(false);
    setShowQRCode(false);
    setShowVerifyMFA(false);
  }

  const cancelMFASetup = () => {
    setShowQRCode(false);
  }

  const handleShowSecretKey = () => {
    setShowSecretKey(prevState => !prevState);
  };

  const cancelForgotPwd = () => {
    setShowVerifyMFA(false)
    setIsError(false);
    setLoading(false);
    navigate("./");
  }

  const handleIdpLogin = async () => {
    try {
      Auth.federatedSignIn({ provider: "ABBSAML" });
    } catch (err) {
    } finally {
    }
  };

  return (
    <>
      {(showSessionTimeout || showPostCannotGiveCodeStep) && (
        <>
          <div className="ReactModal__Overlay ReactModal__Overlay--after-open ABB_CommonUX_Dialog__overlay ABB_CommonUX_Dialog__halfOpacityBackdrop ABB_CommonUX_Dialog__light">
            <Dialog
              className="login-mfa-dialog-container"
              title={showSessionTimeout ? MESSAGES.MFA_SESSION_EXPIRED_TITLE : MESSAGES.MFA_POPUP_TITLE}
            >
              <p>{showSessionTimeout ? MESSAGES.MFA_SESSION_EXPIRED : MESSAGES.MFA_POPUP_CONTENT}</p>

              <Button
                sizeClass={"medium"}
                text="Back to Login"
                type="primary-blue"
                onClick={closeDialog}
              />
            </Dialog>
          </div>
        </>
      )}
      {ShowQRCode ? (
        <div className="mfa-setup-container">
          <div className="ABB_CommonUX_LoginScreen__root ABB_CommonUX_LoginScreen__light login-container">
            <div className="ABB_CommonUX_LoginScreen__header">
              <div />
              <div className="ABB_CommonUX_LoginScreen__logo" />
            </div>
            <div className="ABB_CommonUX_LoginScreen__contentWrapper">
              <div className="ABB_CommonUX_LoginScreen__content">
                <h1 className="ABB_CommonUX_LoginScreen__productName mfa-title">Set up authenticator app</h1>
                <div>
                  <br />
                  <div className="ABB_CommonUX_LoginScreen__customContent" style={{ fontSize: "14px", fontWeight: 500, textAlign: "left" }}>
                    <p> {MESSAGES.MFA_INSTRUCTIONS_STEP_1}
                      <br /> {MESSAGES.MFA_INSTRUCTIONS_STEP_2 + MESSAGES.MFA_INSTRUCTIONS_ALTERNATIVE_STEP}
                      {QRCodeURL && (
                        <div>
                          <canvas id="canvas" width="200" height="200" style={{
                            margin: "0px",
                            padding: "0px"
                          }}></canvas>
                        </div>
                      )}
                      <Link onClick={handleShowSecretKey} discreet={true}>{showSecretKey ? 'Hide Secret Key' : 'Show Secret Key'} </Link> </p>
                    {showSecretKey && (
                      <div id="secret-key">
                        <p> Your secret key is: {QRCodeURL.split('secret=')[1]} </p>
                      </div>
                    )}
                  </div>
                </div>
                <div className="ABB_CommonUX_LoginScreen__form">
                  <div className="ABB_CommonUX_LoginScreen__formRow">
                    <div className="ABB_CommonUX_LoginScreen__customContent" style={{ fontSize: "14px", fontWeight: 600 }}>
                      Enter a code from your authenticator app
                      <div />
                    </div>
                  </div>
                  <div className="ABB_CommonUX_LoginScreen__formRow mfa-form-row">
                    <div className="ABB_CommonUX_LoginScreen__password">
                      <div className="ABB_CommonUX_Input__root ABB_CommonUX_Input__light ABB_CommonUX_Input__normal ABB_CommonUX_Input__isValid ABB_CommonUX_Input__isEmpty">
                        <Input
                          className="ABB_CommonUX_Input__inputElement"
                          type="normal"
                          name="toptp"
                          id="toptp"
                          value={totpCode}
                          onValueChange={(val) => {
                            setIsError(false)
                            setIsSaveEnabled(val.length === 6 ? true : false)
                            settotpCode(val);
                          }} />
                        {ShowMFASettingUpMessage && (
                          <p style={{ color: "green" }}>{MESSAGES.MFA_SETUP_TRIGGER}</p>
                        )}
                        {isError && (
                          <p style={{ color: "red" }} id="error-msg">
                            <Icon
                              name="abb/warning-circle-1"
                              className="incorrect"
                            ></Icon>
                            {localStorage.getItem("error")}
                          </p>
                        )}
                        <br />
                        <br />
                        <Button
                          text="Login"
                          id="mfa-login"
                          disabled={!isSaveEnabled}
                          shape={"rounded"}
                          sizeClass={"small"}
                          type={"primary-black"}
                          onClick={verifyMFASetup}
                        />
                        &nbsp;&nbsp;<Button
                          text="Cancel"
                          id="mfa-cancel"
                          shape={"rounded"}
                          sizeClass={"small"}
                          type={"primary-black"}
                          onClick={cancelMFASetup}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        showVerifyMFA ? (
          <div className="mainmfacontainer">
            <div className="ABB_CommonUX_LoginScreen__root ABB_CommonUX_LoginScreen__light login-container mainbg1">
              <div className="ABB_CommonUX_LoginScreen__header">
                <div />
                <div className="ABB_CommonUX_LoginScreen__logo" />
              </div>
              <div className="ABB_CommonUX_LoginScreen__contentWrapper">
                <div className="ABB_CommonUX_LoginScreen__content">
                  <h1 className="ABB_CommonUX_LoginScreen__productName mfa-title">Verify your identity</h1>
                  <div className="ABB_CommonUX_LoginScreen__form">
                    <div className="ABB_CommonUX_LoginScreen__formRow">
                      <div className="ABB_CommonUX_LoginScreen__customContent" style={{ fontSize: "14px", fontWeight: 600 }}>
                        Enter a code from your authenticator app.
                        <div />
                      </div>
                    </div>
                    <div className="ABB_CommonUX_LoginScreen__formRow mfa-form-row">
                      <div className="ABB_CommonUX_LoginScreen__password">
                        <div className="ABB_CommonUX_Input__root ABB_CommonUX_Input__light ABB_CommonUX_Input__normal ABB_CommonUX_Input__isValid ABB_CommonUX_Input__isEmpty">
                          <Input
                            className="ABB_CommonUX_Input__inputElement"
                            type="normal"
                            name="toptp"
                            id="toptp"
                            value={totpCode}
                            onValueChange={(val) => {
                              setIsError(false)
                              setIsSaveEnabled(val.length === 6 ? true : false)
                              settotpCode(val);
                            }} />
                          {loading && (
                            <p style={{ color: "green" }}>{MESSAGES.SIGN_IN_TRIGGER}</p>
                          )}
                          {isError && (
                            <p style={{ color: "red" }} id="error-msg">
                              <Icon
                                name="abb/warning-circle-1"
                                className="incorrect"
                              ></Icon>
                              {localStorage.getItem("error")}
                            </p>
                          )}
                          <br />
                          <br />
                          <Button
                            text="Login"
                            id="mfa-login"
                            disabled={!isSaveEnabled}
                            shape={"rounded"}
                            sizeClass={"small"}
                            type={"primary-black"}
                            onClick={verifyMFACode}
                          />
                          &nbsp;&nbsp;<Button
                            text="Cancel"
                            id="mfa-cancel"
                            disabled={!isCancelEnabled}
                            shape={"rounded"}
                            sizeClass={"small"}
                            type={"primary-black"}
                            onClick={cancelForgotPwd}
                          />
                          <div>
                            <br />
                            <br />
                            {/* <br />
                        Don't have code? <Link onClick={resetMFA} discreet={true}>Reset MFA</Link>
                        <br /> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) :
          (
            <div className="mainlogin">
              <LoginScreen
                productName="Log in"
                className="login-container mainbg"
                footerText={lawText}
                onLogin={(username, password) => {
                  if (username === "" || password === "") {
                    setIsError(true);
                    localStorage.setItem("error", "Enter Valid Username and password");
                  } else if (username && password) {
                    handleLoginSubmit(username, password);
                  } else {
                    setIsError(true);
                    localStorage.setItem("error", "Enter Valid Username and password");
                  }
                }}
                customContent={(props, state) => {
                  setUsersState(state);
                  return (
                    <>
                      <div id="ad-signup-controls">
                        {/* <UserSession /> */}
                        {/* Dont have an account <Link onClick={gotSignUP} >SignUp</Link> */}
                        {/* <p> Sign in to your CogniEN account </p> */}

                        <div className="ad-container">

                          <span> Don't have an account <Link onClick={gotSignUp}>SignUp</Link></span>
                          <span style={{ marginLeft: "60px" }}>
                            {" "}
                            <Link onClick={handleIdpLogin}>
                              Login with ABB Corporate ID
                            </Link>
                          </span>
                          <br /> <br />
                        </div>

                      </div>
                      <div className="success">
                        {loading && (
                          <p style={{ color: "green" }}>{MESSAGES.SIGN_IN_TRIGGER}</p>
                        )}
                        <div className="success2">
                          {isError && (
                            <p style={{ color: "red" }} id="error-msg">
                              <Icon
                                name="abb/warning-circle-1"
                                className="incorrect"
                              ></Icon>
                              {localStorage.getItem("error")}
                            </p>
                          )}
                        </div>
                      </div>
                    </>
                  );
                }}
                // customButtons={
                //   [
                //     {
                //       text: "Forgot Password?",
                //       handler: () => handleForgotPasswordClick(),
                //     },
                //   ]
                // }
              />
            </div>)

      )}
    </>

  );

}

export default ABBLogin;